import React, { useContext } from "react";
import { Flex, Popover } from "antd";

import SelectDealerForm from "~/components/Forms/SelectDealerForm";
import {
  GetCurrentDealerContext,
  GetCurrentDealerContextPrpos,
} from "~/pages/IvideonDealerRegistry/getCurrentDealer";

import s from "./DealerSelector.less";

export const DealerSelector = () => {
  const language = localStorage.getItem("language");
  const ctx = useContext<GetCurrentDealerContextPrpos | null>(
    GetCurrentDealerContext
  );
  const currentDealer = ctx?.currentDealer;
  const dealerName = currentDealer
    ? language === "en"
      ? currentDealer.DealerNameEn
      : currentDealer.DealerName
    : language === "en"
    ? sessionStorage.getItem("currentDealerNameEn")
    : sessionStorage.getItem("currentDealerName");

  const [dealerPopoverOpen, setDealerPopoverOpen] = React.useState(false);

  return (
    <Flex vertical justify="center" align="start">
      {/* <InfoTooltip title={dealerName}>

      </InfoTooltip> */}
      <Popover
        open={dealerPopoverOpen}
        onOpenChange={setDealerPopoverOpen}
        content={
          <SelectDealerForm onSelect={() => setDealerPopoverOpen(false)} />
        }
        trigger="click"
        placement="bottomLeft"
        overlayClassName={s.dealerPopover}
      >
        <span className={s.dealerSelect}>Выбрать дилера</span>
      </Popover>
      <span className={s.dealerName}>{dealerName}</span>
    </Flex>
  );
};
